export default __webpack_public_path__ + "static/media/RedSeaIslandBackg.005d7b56.jpg";